import { rem } from '@app/utils/sx/functions';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const heading: SxProps<Theme> = {
  mt: { xs: rem(40), md: rem(151) },
  mb: rem(32),
  color: 'text.secondary',
  textAlign: 'left',
};

export const buttonGroup: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'max-content auto',
  justifyContent: { xs: 'center', md: 'flex-start' },
  gap: rem(12),
};

export const contentBox: SxProps<Theme> = {
  display: 'flex',
  justifyContent: { xs: 'center', md: 'flex-end' },
  mt: { xs: rem(24), md: rem(8) },
  mb: rem(24),
};
